import i18n from "i18next";
import moment from "moment";
import Plans from "views/Plans";
import Users from './views/Users';
import Panics from "views/Panics";
import Promos from './views/Promos';
import Banners from "views/Banners";
import CarsList from "./views/CarsList";
import AddMoney from "./views/AddMoney";
import CarTypes from './views/CarTypes';
import AuthLoading from './AuthLoading';
import appConfig from "config/appConfig";
import { useSelector } from "react-redux";
import Withdraws from './views/Withdraws';
import Dashboard from './views/Dashboard';
import LoginPage from "./views/LoginPage";
import AddBooking from "views/Booking/Add";
import AllReports from "./views/AllReports";
import LocationView from "views/LocationView";
import ProtectedRoute from './ProtectedRoute';
import Settings from './views/Settings/Settings';
import { initReactI18next } from "react-i18next";
import Notifications from './views/Notifications';
import BookingHistory from './views/Booking/History';
import { ThemeProvider } from '@mui/material/styles';
import { useThemeApp } from "components/Theme/theme";
import { MuiTheme } from "components/Theme/muiTheme";
import TermCondition from "views/Legal/TermCondition";
import PrivacyPolicy from "./views/Legal/PrivacyPolicy";
import AdmSavedAddresses from "views/AdmSavedAddresses";
import { useJsApiLoader } from '@react-google-maps/api';
import { CssBaseline, GlobalStyles } from "@mui/material";
import CancellationReasons from './views/CancellationReasons';
import { AlertProvider } from "components/alert/AlertProvider";
import { BrowserRouter, Routes, Route } from 'react-router-dom'


i18n
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false
    }
  });

function App() {
  const { colors } = useThemeApp();
  const settings = useSelector((state) => state.settingsdata?.settings);

  useJsApiLoader({
    id: 'google-map',
    googleMapsApiKey: appConfig.REACT_APP_GOOGLE_MAPS_API_KEY as any,
  })



  moment.locale('pt-br');

  moment.defaultFormat = 'DD/MM/YYYY';
  moment.defaultFormatUtc = 'DD/MM/YYYY';

  return (
    <ThemeProvider theme={MuiTheme(colors)}>
      <CssBaseline />
      <GlobalStyles styles={{}} />
      <AuthLoading>
        <AlertProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              <Route path="/promos" element={<ProtectedRoute permit={"admin"}><Promos /></ProtectedRoute>} />
              <Route path="/panics" element={<ProtectedRoute permit={"admin"}><Panics /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute permit={"admin"}><Settings /></ProtectedRoute>} />
              <Route path="/cartypes" element={<ProtectedRoute permit={"admin"}><CarTypes /></ProtectedRoute>} />
              <Route path="/withdraws" element={<ProtectedRoute permit={"admin"}><Withdraws /></ProtectedRoute>} />
              <Route path="/addtowallet" element={<ProtectedRoute permit={"admin"}><AddMoney /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute permit={"admin,fleetadmin"}><Users /></ProtectedRoute>} />
              <Route path="/notifications" element={<ProtectedRoute permit={"admin"}><Notifications /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute permit={"admin,fleetadmin"}><Dashboard /></ProtectedRoute>} />
              <Route path="/cars" element={<ProtectedRoute permit={"admin,fleetadmin"}><CarsList /></ProtectedRoute>} />
              <Route path="/cancelreasons" element={<ProtectedRoute permit={"admin"}><CancellationReasons /></ProtectedRoute>} />
              <Route path="/bookings" element={<ProtectedRoute permit={"admin,fleetadmin"}><BookingHistory /></ProtectedRoute>} />
              {settings?.REACT_APP_PAGOPAR_PLANS_ACTIVE === true && <Route path="/plans" element={<ProtectedRoute permit={"admin"}><Plans /></ProtectedRoute>} />}
              {settings?.premiumFeatures?.REACT_APP_BANNERS === true && <Route path="/banners" element={<ProtectedRoute permit={"admin"}><Banners /></ProtectedRoute>} />}
              <Route path="/allreports/:fleetAdminId?/:fleetAdminName?" element={<ProtectedRoute permit={"admin,fleetadmin"}><AllReports /></ProtectedRoute>} />
              {settings?.premiumFeatures?.REACT_APP_ADM_SAVED_ADDRESSES === true && <Route path="/admSavedAddresses" element={<ProtectedRoute permit={"admin"}><AdmSavedAddresses /></ProtectedRoute>} />}
              {settings?.premiumFeatures?.REACT_APP_ENABLE_ADM_REQUEST_RIDE === true && <Route path="/addbookings" element={<ProtectedRoute permit={"admin,fleetadmin"}><AddBooking /></ProtectedRoute>} />}


              <Route path="/" element={<LoginPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/term-condition" element={<TermCondition />} />
              <Route path="/location/:shareId" element={<LocationView />} />
            </Routes>
          </BrowserRouter>
        </AlertProvider>
      </AuthLoading>
    </ThemeProvider>
  );
}

export default App;